// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip--tooltip--a8aoI","label":"Tooltip--label--8Rka4","arrow":"Tooltip--arrow--rGnt-"};